.banner {
  display: flex;
  flex-direction: column;
  gap: 7px;
  align-items: center;
  justify-content: center;
  width: 264px;
  padding: 13px 18px 9px;
  color: #fff;
  background-color: #303030;
  border-radius: 8px;

  &:hover {
    background-color: rgb(77 77 77);
  }
}

.lead {
  font-size: 13px;
  font-weight: 300;
}

.download {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.8;
}
